import o from"debug";var e=o("mud:common"),r=o("mud:common");e.log=console.debug.bind(console);r.log=console.error.bind(console);export{e as a};
//# sourceMappingURL=chunk-TCWGPC6G.js.map